import styled, { css } from 'styled-components';
import { HEADER_VERSIONS } from '../constants';
import { getBreakpointsForHeaderVersion } from '../utils/getBreakpointsForHeaderVersion';

export enum ZILLOW_NAVBAR_GROUP_SIDE {
    LEFT = 'left',
    RIGHT = 'right',
}

export type ZillowNavbarGroupOfLinksProps = {
    side: ZILLOW_NAVBAR_GROUP_SIDE;
    isMobile?: boolean;
    isMobileNavOpen: boolean;
    version: HEADER_VERSIONS;
};

export const ZillowNavbarSectionsListGroup = styled.div<ZillowNavbarGroupOfLinksProps>`
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    ${({ side, version, isMobileNavOpen, isMobile = false }) => css`
        justify-content: ${side === ZILLOW_NAVBAR_GROUP_SIDE.LEFT ? 'flex-start' : 'flex-end'};
        ${isMobile
            ? css`
                  ${version === HEADER_VERSIONS.SEARCH_MOBILE_ONLY &&
                  !isMobileNavOpen &&
                  css`
                      /* Shrink during search mobile while not open to align the logo image to the left */
                      flex: 0 1;
                  `}
                  @media (min-width: ${getBreakpointsForHeaderVersion(version).DESKTOP}px) {
                      display: none;
                  }
              `
            : css`
                  @media (max-width: ${getBreakpointsForHeaderVersion(version).MOBILE}px) {
                      display: none;
                  }
              `}
    `}
`;
